import "../layouts/default";
import "../ui/slider";
import { updateLazy } from "Functions/lazy";

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();
});
